module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2b2da989.png";